import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import { isEmpty } from 'lodash';

import {
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    Divider,
    FormControlLabel,
    Radio,
    colors
} from '@material-ui/core';

import {
    ColorPicker,
    FieldError
} from '../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField,
    CheckboxWithLabel,
    RadioGroup
} from 'formik-material-ui';

import { PageContext } from '../PageContext';
import { PluginContext } from '../../../contexts';

import { MenuLayoutType, UserLoginType } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    sectionTitle: {
        color: "#7957d5"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        //marginLeft: "-6px"
    }
}));

export const InfoForm = ({
    formRef,
    errors,
    validationSchema,
    disabled,
    onBlur,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        plugin
    } = useContext(PluginContext);

    const {
        settings,
    } = state;

    const getInitialValues = () => {
        return {
            appTitle: !isEmpty(settings) && settings.appTitle ? settings.appTitle : "",
            menuTitle: !isEmpty(settings) && settings.menuTitle ? settings.menuTitle : "",
            bundleId: !isEmpty(settings) && settings.bundleId ? settings.bundleId : "",
            versionNumber: !isEmpty(settings) && settings.versionNumber ? settings.versionNumber : "",
            shareAppIos: !isEmpty(settings) && settings.shareAppIos ? settings.shareAppIos : "",
            shareAppAndroid: !isEmpty(settings) && settings.shareAppAndroid ? settings.shareAppAndroid : "",
            enableAppMenu: !isEmpty(settings) && settings.enableAppMenu !== undefined ? settings.enableAppMenu : true,
            appMenuLayout: !isEmpty(settings) && settings.appMenuLayout ? settings.appMenuLayout : MenuLayoutType.Drawer,
            homeUrl: !isEmpty(settings) && settings.homeUrl ? settings.homeUrl : "",
            appPrimaryColor: !isEmpty(settings) && settings.appPrimaryColor ? settings.appPrimaryColor : "#7957d5",
            appSecondaryColor: !isEmpty(settings) && settings.appSecondaryColor ? settings.appSecondaryColor : "#7957d5",
            entryTextColor: !isEmpty(settings) && settings.entryTextColor ? settings.entryTextColor : "#000",
            entryBackgroundColor: !isEmpty(settings) && settings.entryBackgroundColor ? settings.entryBackgroundColor : "#fff",
            errorTextColor: !isEmpty(settings) && settings.errorTextColor ? settings.errorTextColor : "#f00",
            appTitleColor: !isEmpty(settings) && settings.appTitleColor ? settings.appTitleColor : "#fff",
            colorHeaderMenu: !isEmpty(settings) && settings.colorHeaderMenu ? settings.colorHeaderMenu : "#fff",
            menuTitleBackgroundColor: !isEmpty(settings) && settings.menuTitleBackgroundColor ? settings.menuTitleBackgroundColor : "#7957d5",
            menuItemsBackgroundColor: !isEmpty(settings) && settings.menuItemsBackgroundColor ? settings.menuItemsBackgroundColor : "#fff",
            menuItemsTextColor: !isEmpty(settings) && settings.menuItemsTextColor ? settings.menuItemsTextColor : "#515151",
            menuBackgroundColor: !isEmpty(settings) && settings.menuBackgroundColor ? settings.menuBackgroundColor : "#fff",
            useLightStatusBar: !isEmpty(settings) && settings.useLightStatusBar !== undefined ? settings.useLightStatusBar : false,
            useUserLogin: !isEmpty(settings) && settings.useUserLogin !== undefined ? settings.useUserLogin : false,
            userLoginType: !isEmpty(settings) && settings.userLoginType ? settings.userLoginType : UserLoginType.Always,

            // This field is readonly and the purpose of this field is to show the user 
            // the current site domain to use during the purchase process
            licenseId: plugin.siteUid
        };
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardContent>
                <Container maxWidth="lg" className={classes.content}>
                    <Formik
                        enableReinitialize
                        initialValues={getInitialValues()}
                        onSubmit={submitClickHandler}
                        innerRef={formRef}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        validate={(values) => {
                            if (onBlur) onBlur(values);
                        }}>
                        {(props) => {
                            const {
                                values,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue,
                            } = props;
                            return (
                                <Form noValidate autoComplete="off">
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography className={classes.sectionTitle} variant="h6">
                                                {t("LabelInfoGeneral")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="licenseId"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelLicenseId")}
                                                helperText={t("HelperLicenseId")}
                                                component={TextField}
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="appTitle"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelAppTitle")}
                                                helperText={t("HelperAppTitle")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="appTitle"
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="bundleId"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelBundleId")}
                                                helperText={t("HelperBundleId")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="bundleId"
                                                errors={errors}
                                            />
                                        </Grid>
                                     {
                                        /*
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="versionNumber"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelVersionNumber")}
                                                helperText={t("HelperVersionNumber")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="versionNumber"
                                                errors={errors}
                                            />
                                        </Grid>
                                        */
                                       }

                                        {/*
                                           <Grid item xs={12}>
                                               <Typography className={classes.sectionTitle} variant="h6">
                                                   {t("LabelInfoAuthentication")}
                                               </Typography>
                                           </Grid>
                                           <Grid item xs={12}>
                                               <Field
                                                   type="checkbox"
                                                   name="useUserLogin"
                                                   component={CheckboxWithLabel}
                                                   Label={{ label: t("LabelUseUserLogin") }}
                                                   disabled={disabled}
                                               />
                                               <br />
                                               <Typography variant="caption" style={{ marginLeft: "16px" }}>
                                                   {t("HelperUseUserLogin")}
                                               </Typography>
                                           </Grid>
                                           {values.useUserLogin &&
                                               <Grid item xs={12}>
                                                   <Field component={RadioGroup} name="userLoginType">
                                                       <FormControlLabel
                                                           value={UserLoginType.Always}
                                                           control={<Radio disabled={isSubmitting} />}
                                                           label={t("LabelLoginAlways")}
                                                           disabled={disabled}
                                                       />
                                                       <FormControlLabel
                                                           value={UserLoginType.Action}
                                                           control={<Radio disabled={isSubmitting} />}
                                                           label={t("LabelLoginAction")}
                                                           disabled={disabled}
                                                       />
                                                       <FormControlLabel
                                                           value={UserLoginType.Code}
                                                           control={<Radio disabled={isSubmitting} />}
                                                           label={t("LabelLoginCode")}
                                                           disabled={disabled}
                                                       />
                                                   </Field>
                                               </Grid>
                                          }
                                        */}
                                        
                                    </Grid>
                                </Form>
                            );
                        }}
                    </Formik>
                </Container>
            </CardContent>
        </Card >
    );
}